import {
  assign,
  omit,
  isMatch,
  isEqual,
  isString,
  isArray,
} from 'lodash';

const postMessageHandler = (ensureOrigin) => {
  let watched = [];

  const on = (stringOrObject, callback) => {
    if (isString(stringOrObject)) {
      watched = [...watched, { callback, _string: stringOrObject }];
    } else {
      watched = [...watched, assign(stringOrObject, { callback })];
    }
  };

  const off = (stringOrObject) => {
    const watchedStringOrObject = isString(stringOrObject)
      ? { _string: stringOrObject }
      : stringOrObject;

    watched = watched.reduce((acc, watch) => {
      const remainingWatch = omit(watch, ['callback']);

      if (!isEqual(remainingWatch, watchedStringOrObject)) {
        return [...acc, ...[watch]];
      }

      return acc;
    }, []);
  };

  const eventListenerHandler = (event) => {
    const { data, origin } = event;
    if (ensureOrigin && !ensureOrigin(origin)) {
      return;
    }

    watched.forEach((watching) => {
      const { callback, _string } = watching;
      const remainingWatching = omit(watching, ['callback']);

      const isMatched = (_string && (new RegExp(_string)).test(data))
        || isMatch(data, remainingWatching);

      if (isMatched) {
        return callback(data);
      }
    });
  };

  if (!window.widgetMessageEventHandlerAlreadyRegistered) {
    window.addEventListener('message', eventListenerHandler, false);
    window.widgetMessageEventHandlerAlreadyRegistered = true;
  }

  return {
    on,
    off,
  };
};

export default postMessageHandler;



// WEBPACK FOOTER //
// ./application/src/services/postMessageHandler.js